// ─── Shared design tokens ───────────────────────────────────────────────────
// Single source of truth for colors used across App.jsx and src/workbench/*.
// Keeping this in its own file (instead of duplicated consts) means the
// Workbench UI and the existing pitch/timeline/stats components can never
// visually drift apart.

export const T = {
  bg:      "#070A0F",
  surface: "#0E1318",
  panel:   "#131920",
  panel2:  "#171E27",
  border:  "#1E2733",
  textPri: "#E8EFF7",
  textSec: "#7A8FA6",
  textDim: "#3D5068",
  team0:   "#FF2D6B",
  team1:   "#00D4FF",
  ref:     "#FFB800",
  accent:  "#3D8EF0",
  warn:    "#F59E0B",
  danger:  "#EF4444",
  good:    "#1BAF7A",
  scenarioA: "#1BAF7A",
  scenarioB: "#8B5CF6",
};

export const TEAM_COLORS = { 0: T.team0, 1: T.team1, 3: T.ref };
export const TEAM_NAMES  = { 0: "Team A", 1: "Team B", 3: "Referee" };
export const FPS = 25;
